<template>
    <div class="home-page">
		<Header></Header>
		<div class="home-content">
      <div class="content crfff ac por">
        <div class="home-block1 disflex">
          <div class="font-left disflex" @click="getToNav('myAccount')">

              <img class="por account-img" style="width: 135px;height: 135px;border-radius: 100%" :src="info.avatar" />

            <div class="font-account">
              <div class="fw7">{{info.nickname}}</div>
              <p>{{$t('PhoneNo')}} : {{info.mobile}}</p>
              <p>{{$t('Level')}} : {{info.level}}</p>
            </div>
          </div>
          <div class="font-right" @click="getToNav('rankList')">
            <img class="por" src="../../static/images/home-img3.png">
            <div class="font-rank">
              <div class="" style="line-height: 22px;margin-bottom: 15px;">{{$t('Rank')}}</div>
              <p class="rank-num">{{info.rank}}</p>
            </div>
          </div>
        </div>
        <div class="disflex mt30" style="justify-content: center;">
          <div class="home-block2 disflex" @click="getToNav('RedeemCenter')">
            <div class="disflex" style="justify-content: center;">
              <div class="">
                <img src="../../static/images/home-img4.png">
                <div class="block2-font">
                  <div class="fw7">{{$t('RedeemCenter')}}</div>
                  <div class="">{{$t('redeemTips1')}}:</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="home-block3 disflex" @click="getSub">
              <div class="block2-font">
                <div class="fw7">{{$t('BuyChances')}}</div>
              </div>
              <img src="../../static/images/home-img5.png">
            </div>
            <div class="home-block4 disflex" @click="isChooseShow=true">
              <div class="block2-font">
                <div class="fw7">{{$t('Categories')}}</div>
                <div class="">{{$t('ChooseHere')}}:</div>
              </div>
              <img style="margin-left:10px;" src="../../static/images/home-img6.png">
            </div>
          </div>
        </div>
        <div class="home-content2">
          <div class="home-block5 disflex" @click="goBattleRoom('waitRobot')">
            <div class="block2-font">
              <div class="fw7 cr755dfa">{{$t('game1T')}}</div>
              <div class="">{{$t('game1C')}}</div>
            </div>
            <img style="margin-left:10px;" src="../../static/images/home-img7.png">
          </div>
          <div class="home-block5 disflex" @click="goBattleRoom('paiwei')">
            <div class="block2-font">
              <div class="fw7 crebac36">{{$t('game2T')}}</div>
              <div class="">{{$t('game2C')}}</div>
            </div>
            <img style="margin-left:10px;" src="../../static/images/home-img8.png">
          </div>
          <div class="home-block5 disflex" @click="goBattleRoom('pk')">
            <div class="block2-font">
              <div class="fw7 cr606789">{{$t('game3T')}}</div>
              <div class="">{{$t('game3C')}}</div>
            </div>
            <img style="margin-left:10px;" src="../../static/images/home-img9.png">
          </div>
          <div class="home-block5 disflex"  @click="goBattleRoom('single')">
            <div class="block2-font" style="width: 340px;">
              <div class="fw7 crf66257">{{$t('game4T')}}</div>
              <div class="">{{$t('game4C')}}</div>
            </div>
            <img style="margin-left:10px;position: absolute;right: 0;" src="../../static/images/home-img10.png">
          </div>
        </div>
      </div>
      <div class="home-bottom disflex">
        <div class="bt-icon1" @click="getToNav('rankList')">
          <img src="../../static/images/icon1.png">
          <span class="">{{$t('Ranking')}}</span>
        </div>
        <div class="bt-icon1" @click="getToNav('redeemList')">
          <img src="../../static/images/icon2.png">
          <span class="">{{$t('RedeemList')}}</span>
        </div>
        <div class="bt-icon1" @click="getToNav('myAccount')">
          <img src="../../static/images/icon3.png">
          <span class="">{{$t('Settings')}}</span>
        </div>
      </div>
		</div>
      <div class="footer mt100">
        <div class="home-bottom ac mt50">
          <div class="footer-content ac">
            <a class="crfff" href="#/faq">{{$t('FAQ')}}</a>
            <a class="crfff" href="#/termsAndCondition">{{$t('TC')}}</a>
          </div>
        </div>
        <div class="copyright">{{$t('Copyright')}}</div>
      </div>
      <div class="modal defModal" v-if="isChooseShow">
        <div class="modal-bg"></div>
        <div class="modal-content choose-modal-content">
          <div class="title">{{$t('ChooseTitle')}}</div>
          <div class="choose-list">
            <div class="choose-li" :class="{'active':isSelect==item.id}" v-for="(item,index) in chooseList" @click="clickSelect(item.id)">
              <div class="disflex"><img class="choose-img" :src="item.image" /></div>
              <span><span class="dian"></span>{{item.name}}</span>
            </div>
          </div>
          <div class="">
            <button class="btn btn-blue" @click="getChooseNav()">{{$t('Save')}}</button>
            <button class="btn btn-none mt20" @click="chooseCancel">{{$t('Back')}}</button>
          </div>
        </div>
      </div>
      <Dialog ref="otpDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="" slot="mdBox">
            <div class="otp-title" v-if="buyTitleType === 'buy'">{{$t('BuyChances')}}</div>
            <div class="otp-title" v-else-if="buyTitleType === 'enough'">{{$t('ChanceEnough')}}</div>
              <div class="otp-modal ac">
                <img style="margin: -40px auto;" src="../../static/images/buy-img.png">
                <div class="otp-font">
                  {{$t('BuyChancesC')}}
                </div>
               <!-- <div class="input-div">
                 <div class="span fs33 crfff app-en fw7" style="margin:50px 0 20px;">OTP</div>
                 <div class="input-item" style="background: none;">
                   <div class="input-item2 disflex">
                     <input class="input-item input" v-model="otp" ref="getFocus2" maxlength="4" type="number" style="width: 100%;height:80px;" placeholder="">
                     <button class="btn btn-red" style="padding: 0 10px;min-height: 80px;line-height: 80px;min-width: 160px;margin-left:5px;font-size: 30px;" :class="{disable:codeText != $t('getCode')}" type="none" :disabled="codeText != $t('getCode')" @click="getSendOtp">{{codeText}}</button>
                   </div>
                 </div>
               </div> -->
                <div class="mt10 disflex">
                  <button class="btn btn-none" style="border: 2px solid #fff;color:#fff;width: auto;min-width: 250px;" @click="cancelOtpDialog">{{$t('Later')}}</button><!-- :class="{'none':otp==''}" -->
                  <button class="btn btn-blue" style="width: auto;min-width: 250px;" @click="getSubmit">{{$t('BuyMore')}}</button><!-- :class="{'none':otp==''}" -->
                </div>
              </div>
          </div>
      </Dialog>
	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        isShow:null,
        isEN:'bur',
        mobile:'',
         otp:'',
         codeText:'',
         isReturn:false,
         chooseList:[
           'Movies','Musics','Countries','Sports'
         ],
         isSelect:false,
         isChooseShow:false,
         info:{},
         buyTitleType: 'buy', // 或 'enough'
      }
    },
	created(){
    this.isEN = localStorage.getItem('lang')
    this.codeText = this.$t('getCode');
    this.getHome()
	},
    methods: {
      goBattleRoom(url){
         if (this.info.score <1){
           let that =this;
           that.buyTitleType = "enough"
           that.$refs.otpDialog.showMaskFun();
           return;
         }
        this.$router.push({path:'/'+url});
      },
      getToNav(url){
        this.$router.push({path:'/'+url});
      },
      clickSelect(item){
        this.isSelect = item
      },
      getChooseNav(){
        let that = this
        that.$parent.loadModal(true);
        let data = {
          "question_type_id":that.isSelect
        }
        that.$api.post('/api/index/select_question_type',data,r =>{
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,80);
          that.isChooseShow = false
          return;
        })
      },
      chooseCancel(){
        this.isChooseShow = false
      },
      getHome(){
        this.getUserInfo();
        this.getQuestionType();
      },
      getUserInfo(){
        let that =this;
        that.$api.get('/api/user/info',null,r =>{
          that.$parent.returnCode(r,function(){
            that.info = r.data
          });
        })
      },
      getQuestionType(){
        let that =this;
        that.$api.get('/api/index/question_type',null,r =>{
          that.$parent.returnCode(r,function(){
            that.chooseList=r.data.question_type
            that.isSelect=r.data.user_type_id
          });
        })
      },
      cancelOtpDialog(){
        this.$refs.otpDialog.closeMask();
      },
      getSubmit(){
        let that = this
        that.$parent.loadModal(true);
        that.$api.post('/api/index/buy',null,r =>{
        	that.$parent.returnCode(r,function(){
        		that.$parent.loadModal(false);
            if (r.code == 1){
              that.$refs.otpDialog.closeMask();
              that.$utils.alertText(r.msg,80, 800);
              that.getUserInfo();
            }else{
              that.$utils.alertText(r.msg,80, 3000);
            }
        	});
        })
      },
      getSub(type){
        let that =this;
        that.buyTitleType = "buy"
        that.$refs.otpDialog.showMaskFun();
      },
	}
}
</script>
<style scoped>
  .choose-modal-content{position: absolute;
      top: auto;
      bottom: 0;
      transform: translate(0, 0);
      background: #f6f6f6;
      width: 100%;
      left: 0;
      min-height: 600px;padding:40px}
    .choose-modal-content .title{color:#4c5bff;text-align: center;margin-bottom: 20px;font-size: 36px}
    .choose-list{padding:20px 0 40px}
    .dian{    position: absolute;
    right: 10px;
    top: 10px;}
    .active .dian{background: url(../../static/images/gou.png) no-repeat 0 0;width: 36px;height: 36px;background-size:cover;border: none;}
    .choose-li{padding:20px 0}
  .close{
    background: rgb(255 255 255 / 20%);
    color: #fff;
    width: 100px;
    height: 100px;
    font-size: 60px;
    margin: 30px auto 0;
    border-radius: 100px;
  }
  .new-img{margin: 40px 40px 0;width: auto;}
  .new-img .img-b{width: 48%;border: 4px solid #0062ff;
    border-radius: 10px;}
  .img-b img{width: 100%;border-radius: 10px;}
</style>



// WEBPACK FOOTER //
// src/page/index.vue